import { forEach } from 'lodash';

export const buildActiveCallsData = activeCallsSamplingData => {
    const categories = [];
    const calls = [];

    forEach(activeCallsSamplingData, (sampleData, index) => {
        if (index % 5 === 0 || +sampleData.active_calls > 0) {
            categories.push(new Date(sampleData.s * 1e3).toISOString());
            calls.push(sampleData.active_calls);
        }
    });

    return {
        categories,
        calls
    };
};
